module.exports = __webpack_public_path__ + "static/media/share.10689775.png";